export const LogoIcon = (props: any) => {
    return (
        <svg width="86" height="33" viewBox="0 0 86 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9591 0H36.7631L24.3611 16.8413H0L11.9591 0ZM85.4853 0L73.0833 16.8413H52.132C50.7021 16.8413 49.8685 15.227 50.6964 14.0612L60.6812 0H85.4853ZM36.7642 33L48.7233 16.8407L36.7642 0.000329241L24.362 16.841L36.7642 33Z" fill="#009FDA"/>
        </svg>
    )
}